/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseWorklistPagedResult } from '../../models/course-worklist-paged-result';
import { CriteriaCourseWorklist } from '../../models/criteria-course-worklist';

export interface ApiWorklistAllRequestPost$Params {
      body?: CriteriaCourseWorklist
}

export function apiWorklistAllRequestPost(http: HttpClient, rootUrl: string, params?: ApiWorklistAllRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseWorklistPagedResult>> {
  const rb = new RequestBuilder(rootUrl, apiWorklistAllRequestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseWorklistPagedResult>;
    })
  );
}

apiWorklistAllRequestPost.PATH = '/api/Worklist/AllRequest';
